<ng-container *ngIf="!ready">
    <div class="cf-dlg-loading"><div class="cf-dlg-loading__dots"><span></span><span></span><span></span></div></div>
</ng-container>
<ng-container *ngIf="ready">
    <div class="bg-white">
        <div class="mainBody p-3">
            <form onkeypress="return event.keyCode != 13;">
                <strong>Nueva cuenta contable</strong>
                <hr>
                <div class="flex-container">
                    <div class="second-column">
                        <app-input inputType="text" placeholder="Nombre" name="accountingModel.name"
                            [isRequired]="true" [(ngModel)]="accountingModel.name"></app-input>

                        <br />

                        <mat-form-field class="w-100">
                            <input type="text" matInput placeholder="Número de cuenta" name="accountingModel.number"
                                maxlength="{{userCompany.accountLength}}" required [(ngModel)]="accountingModel.number">
                        </mat-form-field>
                    </div>
                    <div class="first-column">
                        <app-select name="accountingModel.type" [(ngModel)]="accountingModel.type"
                            [config]="{ label: 'Tipo', required: true, loadOptions: () => accountingModelTypeOptions }">
                        </app-select>

                        <br />

                        <app-input inputType="text" placeholder="Grupo" name="accountingModel.accountGroup"
                            [isRequired]="true" [(ngModel)]="accountingModel.accountGroup"></app-input>
                    </div>
                </div>
                <div class="mb-3 text-center">
                    <button class="bg-white" mat-stroked-button (click)="save(accountingModel)">
                        Guardar</button>
                </div>
            </form>
        </div>
    </div>
</ng-container>
